module.exports = __webpack_public_path__ + "assets/img/2.ef2987c7.png";